const Goals = {
  sigma: 'sigma',
  s: 's',
  p: 'p',
  ho: 'ho',
  pi: 'pi',
};

export default Goals;